import type { IconToken } from '../icons/index';
export interface Heirloom {
  id: string;
  name: string;
  icon: IconToken;
  value: number;
  quip: string;
}

/** Things you start the game owning and can pawn exactly once. */
export const HEIRLOOMS: readonly Heirloom[] = [
  {
    id: 'ps2',
    name: 'PS2 + Guitar Controller',
    icon: ':gamepad:',
    value: 35,
    quip: 'Lucky blows into the memory card like a medic doing CPR.',
  },
  {
    id: 'bass',
    name: "Singin' Sam the Animatronic Bass",
    icon: ':singing-bass:',
    value: 15,
    quip: 'It sings eight seconds of a song nobody can name. Priceless. Worth $15.',
  },
  {
    id: 'hood',
    name: 'NASCAR Hood (signed "Dayle")',
    icon: ':checkered-flag:',
    value: 50,
    quip: '"That ain\'t how you spell it," says Lucky, paying you anyway.',
  },
  {
    id: 'watch',
    name: "Grandpa's Pocket Watch",
    icon: ':pocket-watch:',
    value: 80,
    quip: 'Grandpa would understand. Grandpa pawned it twice himself.',
  },
  {
    id: 'ring',
    name: "Mama's Promise Ring (Cubic Zirconia)",
    icon: ':ring:',
    value: 25,
    quip: 'Lucky holds it up to the light, sighs, and opens the register anyway.',
  },
];

export const PAYDAY_LOAN = {
  amount: 100,
  owed: 150,
} as const;
